import React from "react";
import { Schema } from "@comparaonline/products-schema";

import { SectionAnchor } from "./SectionAnchor";
import { ReviewList } from "./ReviewList";
import { ReviewSummary } from "./ReviewSummary";
import { ReviewForm } from "./ReviewForm";
import { useProduct } from "../../context/product";
import { hasReviews } from "../../../../models/product";
import { useAppContext } from "../../../../lib/appContext";
import { buHasReviewFormEnabled } from "./helpers";

export const Reviews: React.FC = () => {
  const { businessUnitConfig } = useAppContext();
  const { loading, product } = useProduct();
  const hasFormEnabled = buHasReviewFormEnabled(businessUnitConfig);
  if (loading || !product) {
    return null;
  }
  if (!hasReviews(product)) {
    return hasFormEnabled ? <ReviewForm product={product} /> : null;
  }

  const {
    totalByValue,
    averageValue,
    total,
    userReviews
  } = (product as Schema.ProductListProduct).reviews!;
  return (
    <>
      <SectionAnchor />
      <ReviewSummary averageValue={averageValue} total={total} totalByValue={totalByValue} />
      {hasFormEnabled && <ReviewForm product={product} />}
      <ReviewList reviews={userReviews} />
    </>
  );
};
